<template>
    <div class="main">



        


    </div>
</template>

<script>



export default {
    name: "Main",
    methods: {}
}
</script>
<style scoped >
/* width: 450.5px;
height: 901px;
left: 1469px;
top: 629px;

background: #714CDF;
border: 1px solid #714CDF; */
  
    
</style>